import { useEffect, useState } from 'react';

const useFetchCompanyProfile = (companyId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [parsedCompanyData, setParsedCompanyData] = useState(null);

  // Function to fetch complete job offer data
  const fetchJobOfferDetails = async (jobId) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/${jobId}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        console.warn(`Failed to fetch job offer ${jobId}:`, response.status);
        return null;
      }
      
      const data = await response.json();
      return data.data || data;
    } catch (error) {
      console.warn(`Error fetching job offer ${jobId}:`, error);
      return null;
    }
  };

  useEffect(() => {
    const fetchCompanyData = async () => {
      setIsLoading(true);
      try {
        const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/company/${companyId}`;
        
        const response = await fetch(url, {
          method: 'GET',
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! Status: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        
        const companyData = data.data || data;
       
        let completeJobOffers = [];
        if (companyData.jobOffers && companyData.jobOffers.length > 0) {
          
          const jobPromises = companyData.jobOffers.map(async (jobOffer) => {
            // If the job offer already has location data, use it
            if (jobOffer.location && jobOffer.location.address) {
              return jobOffer;
            }
            
            // Otherwise, fetch the complete job offer data
            const completeJobData = await fetchJobOfferDetails(jobOffer.id);
            return completeJobData || jobOffer;
          });
          
          completeJobOffers = await Promise.all(jobPromises);
        }

        const parsedData = {
          name: companyData.name,
          format: companyData.format,
          description: companyData.description,
          jobOffers: completeJobOffers,
          addresses: [],
          profileImageUrl: companyData.profileImageUrl,
          benefits: companyData.benefits,
          locations: companyData.locations || [],
          information: {
            establecimiento: companyData.format,
            especialidad: companyData.specialty,
            locales: companyData.numberOfRestaurants, 
            trabajadores: companyData.workers,
            clientes_semanales: companyData.weeklyAverageClients,
          },
          profileCarouselUrls: companyData.profileCarouselUrls,
        }; 

        setCompanyData(parsedData);
      } catch (error) {
        console.error('🔍 [useFetchCompanyProfile] Error details:', error);
        setError(error.message);
      }
      setIsLoading(false);
    };

    fetchCompanyData();
  }, [companyId]);

  return { isLoading, error, companyData };
};

export default useFetchCompanyProfile;

